import React from "react";

const Group = props => <optgroup {...props} />;

export default Group;
